export const NETWORKFLOATINGIP = 'NETWORKFLOATINGIP'